var discountObj;
var discountAmount;
var server = "https://iheartzshop-api.herokuapp.com/";
//var v2Server = "https://iheartzshop-api-2.herokuapp.com/v1";
var server_local = "http://localhost:3001/";
var facebook_opt_in;
var commentsAndReplies;

//Create Draft Order
function createDraftOrder(redirect, newDraftOrderObject){
  //var windowReference;
  
  setTimeout(function(){
    //if(redirect){
    //	windowReference = window.open();
    //}
    
    var messageType;

    //TODO: Combine into One
    
    //if($("#use-credit-card").is(":checked")){
    //  messageType = 2;
    //}else if(!$("#use-credit-card").is(":checked")){
    //  messageType = 3;      
    //}
    
    if($("#no-direct-checkout").val() === 'true'){
	  messageType = 1;
    }
    
    $.ajax({
      type:    "POST",
      crossDomain: true,
      url:     v2Server + '/draft-order/public/create',
      data:    JSON.stringify(newDraftOrderObject),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      success: function(response) {
        if(response.message == "Update successfully"){
          //if($("#no-direct-checkout").val() === 'false'){
          	//sendInvoice(response.data.draft_order.id, messageType);
          //}
          if(redirect){
            const url = response.data.draft_order.invoice_url+"?step=contact_information";
            window.location.replace(response.data.draft_order.invoice_url+"?step=contact_information");
            //window.open(response.data.draft_order.invoice_url+"?step=contact_information", '_blank');
            //windowReference = windowReference?windowReference:window.open();
            //windowReference.location = response.data.draft_order.invoice_url+"?step=contact_information";

            if($('#checkout-form').length){
              $.ajax({
                type:    "POST",
                crossDomain: true,
                url:     '/cart/clear.js',
                complete: function(response) {
                  //location.reload(); 
                }
              });
            }else{
              //location.reload(); 
            }

            $("#load-wrapper").hide();

          }else{
            if($('#checkout-form').length){
              $.ajax({
                type:    "POST",
                crossDomain: true,
                url:     '/cart/clear.js',
                complete: function(response) {
                  window.location.replace("https://iheartz.shop/pages/thank-you");
                }
              });
            }
          }
        }else{
          if(!response.success){
            /*
            const invalidArray = response.data.invalid;
            for(let i = 0; i < invalidArray.length;i++){
              const temp = document.querySelectorAll("[data-variantid='" + invalidArray[i] + "']");
              
              for (j = 0; j < temp.length; j++) {
                temp[j].innerHTML = `
                  <div style="color: red; display:flex;white-space: nowrap;" >
                      <i class="delete icon"></i> 沒存貨
                  </div>
                `;
              }
            }
            */
            
            $("#load-wrapper").hide();
            alert("不好意思，商品已經沒有存貨或已下架，請先刪除該商品。");
            location.reload();
            
            //window.scrollTo({ top: 0, behavior: 'smooth' });
          }else{
            $("#load-wrapper").hide();
            alert("你的訂單不能建立，請聯絡管理員。");
          };
        }
      }
    });

  }, 100);
  
}
/*
function getDiscount(discountCode, totalPrice){
  $("#load-wrapper").show();
  $.ajax({
    type:    "GET",
    crossDomain: true,
    url:     server + 'api/iheartzshop/v1/custom-discounts/search/' + discountCode,
    complete: function(response) {
      console.log(response);
      if(response.responseJSON.message == "Updated successfully"){
        discountObj = response.responseJSON.data[0];
        
        if(discountObj){
          $("#customer-discount-name").html(response.responseJSON.data[0].name);
          let newPrice = 0;

          console.log(response.responseJSON.data[0].name);
          if(response.responseJSON.data[0].type == "percentage"){
            $("#customer-discount-amount").html("- $" + (totalPrice / 100 * parseInt(response.responseJSON.data[0].amount, 10) / 100));          

            newPrice = (totalPrice / 100) - (totalPrice / 100 * parseInt(response.responseJSON.data[0].amount, 10) / 100);
          }else if(response.responseJSON.data[0].type == "fixed"){
            $("#customer-discount-amount").html("$" + response.responseJSON.data[0].amount);

            newPrice = (totalPrice / 100) - parseInt(response.responseJSON.data[0].amount, 10);
          }


          $("#card-fee-amount").html( (newPrice * 0.035).toFixed(2));
          discountAmount = (totalPrice / 100) - newPrice;
        }
        $("#load-wrapper").hide();
      }
    },
    error: function(response){
        $("#load-wrapper").hide();
    }
  });
}
*/
/*
function sendInvoice(draftOrderID, messageType){
  $.ajax({
    type:    "POST",
    crossDomain: true,
    data: {messageType : messageType },
    url:     server + 'api/iheartzshop/v1/draft-orders/send_invoice/'+draftOrderID,
  });
}
*/
function getFormatDate(dateObj){
 	var date = new Date(dateObj);
  	var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getUTCDate()).padStart(2, '0');
    var currentHours = date.getHours();
    currentHours = ("0" + currentHours).slice(-2);
    var currentMinutes = date.getMinutes();
    currentMinutes = ("0" + currentMinutes).slice(-2);
    
    return year + "-" + month +"-" + day + " " + currentHours + ":" + currentMinutes;
}


//Fetch Draft Orders by Customer ID
function fetchOrdersByCustomerID(customerID, divID){
  $.ajax({
    type:    "GET",
    crossDomain: true,
    url:     "https://iheartzshop-api-2.herokuapp.com/v1/draft-order/"+ customerID,
    complete: function(response) {
      if(response.readyState == 4){
          
          if(divID == "draft-order-display"){
            response.responseJSON.forEach(function(order,i){
              //Currency.rates.TWD = 0.035;
              var orderPrice = window.Currency.convert(parseFloat(order.total_price, 10) * 100, "USD", "TWD" );
              orderPrice = Math.round(orderPrice / 100) * 100 /100 ;
              
              if(order.status == "completed") return;
              
              //console.log(order.invoice_url);
              //if(order.tags.indexOf("IMPORT_ORDER") >= 0 && order.status == "invoice_sent"){
              if(order.line_sent && !order.custom_fields.some(c => c.status == "out-of-stock")){
                $('#pay-draft-order-display').append(`<tr>
                  <td><b>${order.name}</b> <ul>${renderOrderDetails(order.line_items)}</ul></td>
                  <td style="white-space:nowrap;"> ${getFormatDate(order.created_at)}</td>
                  <td style="white-space:nowrap;"><a class="link link--accented" href="/pages/ready-to-checkout?d=${order.id}" style="white-space:nowrap;padding:8px;line-height:1em;margin-top:0;text-decoration:underline;">前往付款</a></td>
                  <td class="table__cell--right">${formatter.format(orderPrice)}</td>
                  </tr>`) 

                if(order.out_note){
                  $('#pay-draft-order-display').append(`
                    <tr><td style="padding-top: 0;" colspan="4"><small style="margin-left:10px;font-style: italic;"> <b>訂單信息</b>：${order.out_note.replace("\n", " ")}</small></td></tr>
                    `);
                }
              }else if(order.custom_fields.some(c => c.status == "out-of-stock")){
                $('#draft-order-display').append(`<tr>
                  <td><ul>${renderOrderDetails(order.line_items)}</ul> </td>
                  <td> ${getFormatDate(order.created_at)}</td>
                  <td>很抱歉，該商品已經斷貨。</td>
                  <td class="table__cell--right">${formatter.format(orderPrice)}</td>
                  </tr>`);

                /*
                if(order.out_note && order.out_note.trim() != ''){
                  $('#draft-order-display').append(`
                    <tr><td style="padding-top: 0;" colspan="4"><small style="margin-left:10px"> <b>訂單信息</b>：${order.out_note.replace("\n", " ")}</small></td></tr>
                    `);
                }
                */
              }else{
                $('#draft-order-display').append(`<tr>
                  <td><b>${order.name}</b> <ul>${renderOrderDetails(order.line_items)}</ul> </td>
                  <td> ${getFormatDate(order.created_at)}</td>
                  <td>等待確認</td>
                  <td class="table__cell--right">${formatter.format(orderPrice)}</td>
                  </tr>`);
              
                if(order.out_note && order.out_note.trim() != ''){
                  $('#draft-order-display').append(`
                    <tr><td style="padding-top: 0;" colspan="4"><small style="margin-left:10px"> <b>訂單信息</b>：${order.out_note.replace("\n", " ")}</small></td></tr>
                    `);
                }
              }
            });

            //Check if Empty
            if($.trim($('#draft-order-display').html()).length == 0){
              $("#draft-order-display").append(`
                <tr><td  colspan="4" style="text-align: center">目前沒有任何訂單～</td></tr>
              `);
            }
            if($.trim($('#pay-draft-order-display').html()).length == 0){
              $("#pay-draft-order-display").append(`
                <tr><td  colspan="4" style="text-align: center">目前沒有任何訂單～</td></tr>
              `);
            }
          }else if( divID == "draft-order-news"){
            let actionCount = 0;
            if(response.responseJSON.data){
              let totalCount = response.responseJSON.data.length || 0;
              response.responseJSON.data.forEach(function(order,i){
                if(order.tags.indexOf("DIRECT_CHECKOUT") < 0 && order.status != 'invoice_sent'){
                 
                }else{
                 actionCount++; 
                }
              });
              
              $('#draft-order-news').append(`<p class="animate__animated animate__pulse animate__infinite"><a class="link link--accented " href="/account">(NEWS) 你有 <b> ${actionCount} 個訂單正等待完成付款</b>, ${totalCount-actionCount} 個訂單等待確認</a></p>`);
            }
          }
      }
    }
  });
  //Return Array
}

//Submit Shopping Cart
function renderOrderDetails(orderObj){
  let res = "";
  orderObj.forEach(function(obj){
    var orderPrice = window.Currency.convert(parseFloat(obj.price, 10) * 100, "USD", "TWD" );
    orderPrice = Math.round(orderPrice / 100) * 100 /100 ;
    
    res += `<li><small> ${obj.name} x ${obj.quantity} $${orderPrice}</small></li>`;
  });

  return res;
}

function cart2Object(cartObject){
  return {
    line_items: renderLineItemsArray(cartObject.items),
    customerID: meta.page.customerId,
    use_customer_default_address: true,
    points: parseInt($("#cash-balance-amount").html())
  };
}

function twd2usd(twd){  
  let amt = parseFloat(twd, 10) * 100;
  let converted = window.Currency.convert(amt, "TWD", "USD");
  let finalAmt = (Math.round(converted)) /100 ;
  
  return finalAmt;
}

function usd2twd(usd){  
  let amt = parseFloat(usd, 10) * 100;
  let converted = window.Currency.convert(amt, "USD", "TWD");
  let finalAmt = (Math.round(converted)) /100 ;
  
  return finalAmt;
}

const customFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',

  // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});


function cartObjectTODraftOrderObject(cartObject, noDirectCheckout){
  const draftOrderObject = {
    data: {
      line_items: renderLineItemsArray(cartObject.items),
      customer: {
        id: meta.page.customerId  
      },
      use_customer_default_address: true,
      tags: noDirectCheckout?'': 'DIRECT_CHECKOUT',
      note_attributes: [
        {
          "name": "Use credit card",
          "value": $("#use-credit-card").is(":checked")
        },
        {
          "name": "Account no first 5 digits",
          "value": $("#account-no").val()
        },
        {
          "name": "Custom Clearance",
          "value": $("#custom-clearance").is(":checked")
        },
        {
          "name": "Non Custom Clearance",
          "value": $("#non-custom-clearance").is(":checked")
        }
      ]
    },
    //useCreditCard: $("#use-credit-card").is(":checked"),
    useCreditCard: false,
    useCashBalance: parseInt($("#cash-balance-amount").html()),
    totalPrice: discountObj?(cartObject.total_price/100)-discountAmount : cartObject.total_price/100,
    redirect: noDirectCheckout
  };
  
  if(discountObj){
    draftOrderObject.data["applied_discount"] = {
      "title": discountObj.name,
      "description": discountObj.code,
      "value": discountAmount,
      "value_type": "fixed_amount",
      "amount": discountAmount,
    }
  }
  return draftOrderObject;
}

function createCustomDraftOrderObject(cartObject, noDirectCheckout){
  const draftOrderObject = {
    data: cartObject.data,
    useCreditCard: true,
    totalPrice: cartObject.total_price
  };
  return draftOrderObject;
}


function renderLineItemsArray(items){
  const result = []
  items.forEach(function(item){
    result.push({
     	variant_id: item.variant_id,
        quantity: item.quantity
    })
  });
  return result;
}

/* CART PAGE */

$( document ).ready(function() {
  	$(this).scrollTop(0);
  
  	if($("#use-credit-card").is(":checked")){ 
      $("#account-pay-wrapper").hide("slow"); 
      //$("#card-fee-display").show("slow"); 
    }else{ 
      $("#account-pay-wrapper").show("slow"); 
      //$("#card-fee-display").hide(); 
    }
  	
  	
  	if($('#draft-order-display').length){
      fetchOrdersByCustomerID(meta.page.customerId, 'draft-order-display');
    }
  
  	if($('#draft-order-news').length){
      fetchOrdersByCustomerID(meta.page.customerId, 'draft-order-news');
    }
});

$("#use-credit-card").on('click', function(e){
  if($("#use-credit-card").is(":checked")){
    $("#account-pay-wrapper").hide("slow");
    //$("#card-fee-display").show("slow"); 
  }else{
    $("#account-pay-wrapper").show("slow");
    //$("#card-fee-display").hide(); 
  }
});

/*
$("#submit-checkout").on("click", function(e){
  e.preventDefault();
  $("#checkout-form").trigger( "submit" );
});


$("#checkout-form").on("submit", function(e){
  e.preventDefault();

  if(!meta.page.customerId){
  	 alert("請先登入會員。 : )"); 
     window.location.replace("https://iheartz.shop/account/login");
    return;
  }

  if(!confirm("親愛的請注意： \r\n \r\n只要你按OK訂單一送出，我們會立刻為您安排採購！不可取消和更改，請暸解，東西買了我們也無法取消及更換，請問您要送出訂單了嗎？")){
    return;
  }
  
  //if(!$("#use-credit-card").is(":checked") && !$("#account-no").val()){
  //  alert("如果選擇銀行轉帳, 請提供銀行帳號最後 5 碼，方便我們核對賬目。 : )"); 
  //  return;
  //}
  
  $("#load-wrapper").show();
  
  
  
  $.ajax({
    type:    "GET",
    url:     '/cart.js',
    complete: function(response) {
      if(response.readyState == 4){
        //createDraftOrder(($("#use-credit-card").is(":checked") == true && $("#no-direct-checkout").val() === 'false'), cartObjectTODraftOrderObject(JSON.parse(response.responseText), $("#no-direct-checkout").val() === 'true'));
        //createDraftOrder(($("#no-direct-checkout").val() === 'false'), cartObjectTODraftOrderObject(JSON.parse(response.responseText), $("#no-direct-checkout").val() === 'true'));
        createDraftOrder(($("#no-direct-checkout").val() === 'false'), cart2Object(JSON.parse(response.responseText)));
      }
    }
  });
});
*/



$("#card-payment-submit").on("click", function(event){
  event.preventDefault();
  $("#load-wrapper").show();

  if(!meta.page.customerId){
    alert("請先登入會員。 : )"); 
    window.location.replace("https://iheartz.shop/account/login");
    return;
  }
  
  //$(document.body).css({'cursor' : 'wait'});
  
  const customDraftOrder = {
    data:{
      line_items: [
        {
          title: "訂單刷卡 (" + $('input[name ="order-no"]').val() + ")",
          price: $('input[name ="order-price"]').val(),
          quantity: 1
        }
      ],
      customer: {
        id: meta.page.customerId  
      },
      use_customer_default_address: true,
      tags: 'CARD_ORDER',
      note_attributes: [
        {
          "name": "Use credit card",
          "value": true
        }      
      ],
      tax_exempt: true,
    }, 
    total_price: $('input[name ="order-price"]').val()
  };
  
  createDraftOrder(true, createCustomDraftOrderObject(customDraftOrder, false));
	
});

/*
$("#custom-discount-button").on("click", function(event){
  event.preventDefault();
  $.ajax({
    type:    "GET",
    url:     '/cart.js',
    complete: function(response) {
      if(response.readyState == 4){
        getDiscount($("#discount-code").val(),JSON.parse(response.responseText).total_price);
      }
    }
  });
});
*/
/* Reply & Comment */

function getFormData($form){
  var unindexed_array = $form.serializeArray();
  var indexed_array = {};

  $.map(unindexed_array, function(n, i){
    indexed_array[n['name']] = n['value'];
  });

  return indexed_array;
}

function initilizeCommentsAndReplies(commentsAndReplies){
  var commentHtml = '';
  
  commentsAndReplies.forEach(comment => {
     var repliesHTML = '';
    
    if(comment.replies){
       comment.replies.forEach(reply => {
					repliesHTML += `<div class="article-comment-reply">
                    <div class="article-comment__inner">
                    <span class="article-comment__author text--strong">${reply.customerName}</span><span> ${reply.lastUpdateDate}</span>
					
                    <div class="article-comment__content rte">
                    <p class="comment-body">${reply.comment}</p>
                    </div>
                    </div>
                    </div>`
                                        });
    }
      commentHtml += `<div class="article-comment">
                    <img class="article-comment__gravatar" src="//www.gravatar.com/avatar/de943f53b0af9217f8f6443d0defbf52?s=100" alt="天蚍蜉" />
                    <div class="article-comment__inner">
                    <p class="article-comment__author text--strong">${comment.customerName}</p>
					<time class="article-comment__date">${comment.lastUpdateDate}</time>
                    <div class="article-comment__content rte">
                    <p class="comment-body">${comment.comment}</p>
					<button class="link link--accented custom-reply" data-replyid="${comment.id}">回覆</button>
					</div>
                    </div>
                    </div>` + repliesHTML;

  });

	//console.log(commentHtml);
  
  $(".article__comment-list-heading").after(commentHtml);
}

/*
function getComments(shopID, blogID, articleID){
  //console.log(customerEmail);
  $.ajax({
    type:    "GET",
    crossDomain: true,
    url:     server + 'api/iheartzshop/v1/custom-comments/' + shopID + '/' + blogID + '/' + articleID,
    complete: function(response) {
      if(response.readyState == 4){
        commentsAndReplies = JSON.parse(response.responseText).data;
        //console.log(commentsAndReplies.commentAndReplies);
        if(commentsAndReplies)
	        initilizeCommentsAndReplies(commentsAndReplies.commentAndReplies);
      }
    }
  });
}
*/

$(".article__comment-list").on('click', '.custom-reply', function(event){
  event.preventDefault();
  
  if($(".article__comment-form-title").next(".reply-comment")[0]){
    $(".article__comment-form-title").next(".reply-comment")[0].remove();
  }
  
  var quoteContent = $(this).prev($(".comment-body"))[0].innerHTML;
  
  $("#replyComment").val(quoteContent);
  $("#replyCommentID").val($(this).data("replyid"));
    
  var quoteContentHTML = "<p class='reply-comment'> 回覆留言: " + quoteContent + "</p>";
  $(".article__comment-form-title").after(quoteContentHTML);

  $([document.documentElement, document.body]).animate({
    scrollTop: $(".reply-comment").offset().top - 200
  }, 500);
  
  
});

$( "#custom_comment_form" ).submit(function( event ) {
  event.preventDefault();

  var $form = $("#custom_comment_form");
  var data = getFormData($form);
  

  var newComment = {
		    id: commentsAndReplies? commentsAndReplies.commentAndReplies.length: 0,
            comment: data.commentBody,
            customerID: data.customerID,
            customerName: data.customerName,
            lastUpdateDate: new Date()
          };

  if(data.replyCommentID != ''){
    var commentFound = commentsAndReplies.commentAndReplies.find(ele=>ele.id == data.replyCommentID);
	
    if(commentFound["replies"]){
      commentFound["replies"].push({
        comment: data.commentBody,
        customerID: data.customerID,
        customerName: data.customerName,
        lastUpdateDate: new Date()    	
      });
    }else{
      commentFound["replies"] = [{
        comment: data.commentBody,
        customerID: data.customerID,
        customerName: data.customerName,
        lastUpdateDate: new Date()    	
      }];
    }

    var commentObject = { commentAndReplies: commentsAndReplies }
    }else{

      if(commentsAndReplies){
        commentsAndReplies["commentAndReplies"].push(newComment);
        var commentObject = { commentAndReplies: commentsAndReplies }
        }else{
          var commentObject = {
            commentAndReplies: {
              shopID: data.shopID,
              blogID: data.blogID,
              articleID: data.articleID,
              commentAndReplies: [newComment]
            }
          }
          }
    }
  
  $.ajax({
    type:    "POST",
    crossDomain: true,
    url:     server + 'api/iheartzshop/v1/custom-comments',
    data:    JSON.stringify(commentObject),
    contentType: "application/json; charset=utf-8",
    dataType: "json"
  });
  
  location.reload();
});

function FBLogout(){
  localStorage.removeItem("_FBAccessToken");

  //setTimeout(function() {
    //window.location.href = "https://iheartz.shop/account/logout";
  //}, 1000);

  //localStorage['_FBAccessToken'] = "";
  
  setTimeout(function() {
    try {  
      FB.getLoginStatus((response) => {
        if (response.status != "success") {
          setTimeout(function() {
            window.location.href = "https://iheartz.shop/account/logout";
          }, 1000);
        }
        FB.logout(function(response) {
          setTimeout(function() {
            window.location.href = "https://iheartz.shop/account/logout";
          }, 1000);
        });
      });
    } catch (error) {
      setTimeout(function() {
        window.location.href = "https://iheartz.shop/account/logout";
      }, 1000);
    } finally {
       window.location.href = "https://iheartz.shop/account/logout";
    }
  }, 1000);
  
  
}  

$(document.body).on('click', '.report-deposit' ,function(event){
  event.preventDefault();

  $("#load-wrapper").show();
  reportDesposit($(this).data("orderid"), $(this).data("tags"));
});

function reportDesposit(orderID, tags){
  var updateRequest = {
    id: orderID,
    data: {
      "draft_order": {
        "id": orderID,
        "tags": tags == "" ? "REPORT_DEPOSIT": tags + ",REPORT_DEPOSIT"
      }
    }
  }
    $.ajax({
      type:    "PUT",
      crossDomain: true,
      url:     server + 'api/iheartzshop/v1/draft-orders/update',
      data:    JSON.stringify(updateRequest),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      success: function(response){
        location.reload();
      }
    });
}


  